<template>
  <v-layout align-center justify-center>
    <v-card style="border-radius: 15px;">
      <v-card-text>
        <v-layout class="mb-2" align-center column>
          <v-btn flat icon absolute right to="SettingProvider">
            <v-icon>settings</v-icon>
          </v-btn>
          <div style="background-color: rgb(1, 31, 54);
            border-radius: 100%;
            padding: 20px 10px;
            margin-bottom: 18px;">
            <img src="/static/favicon/login-icon.svg" width="70" alt="TBS Login">
          </div>
        </v-layout>
        <v-form class="pb-4" v-model="formValid" @submit.prevent="signin" ref="form">
          <v-text-field
            label="Email/Username"
            v-model="login"
            required
            autofocus
            class="float-label"
            :error-messages="loginErrorMessages"
            :rules="[
              value => !!value || 'username or email is required',
            ]"
          ></v-text-field>
          <v-text-field
            label="Password"
            class="float-label"
            v-model="password"
            :append-icon="passwordHidden ? 'visibility' : 'visibility_off'"
            :append-icon-cb="() => (passwordHidden = !passwordHidden)"
            :type="passwordHidden ? 'password' : 'text'"
            required
            :rules="[
              value => !!value || 'password is required',
            ]"
          ></v-text-field>
          <v-btn
            fab
            class="mx-2"
            type="submit"
            style="background-color: rgb(1 82 145);
              position: absolute;
              left: calc(50% - 35px);
              right: 0px;"
            :loading="loading" @click="() => {}">
            <v-icon style="color: white;">chevron_right</v-icon>
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ProgressBtn from './ProgressBtn';
import Redirect from '../services/redirect';

export default {
  name: 'Login',
  data: () => ({
    login: null,
    loginErrorMessages: [],
    password: null,
    passwordHidden: true,
    formValid: true,
    loading: false,
  }),
  components: {
    ProgressBtn,
  },
  computed: {
    ...mapGetters({
      domain: 'Acacia/Utils/Domain',
      currentPIN: 'Acacia/Models/PIN/Get',
    }),
    loginByEmail() {
      return { email: this.login, password: this.password };
    },
    loginByUsername() {
      return { username: this.login, password: this.password };
    },
  },
  methods: {
    ...mapActions({
      userLogin: 'AccessProvider/Users/Login',
      getPIN: 'SettingProvider/PIN/getByPIN',
      addSnackbar: 'addSnackbar',
      addSnackbarErrorHandler: 'addSnackbarErrorHandler',
    }),
    signin() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const pinToSet = this.currentPIN && this.currentPIN.pin ? this.currentPIN.pin : 'APRO';
        this.getPIN(String(pinToSet).toUpperCase())
          .then(() => {
            this.userLogin({ login: this.login, password: this.password })
              .then(this.onSuccessful)
              .catch(this.onError);
          })
          .catch(this.onError)
          .finally(() => {
            this.loading = false;
          });
      }
    },
    onSuccessful() {
      this.loading = false;
      Redirect(this.$store, this.$route);
    },
    onError(error) {
      if (error && error.response && error.response.data &&
        error.response.data.error && error.response.data.error.code) {
        if (error.response.data.error.code === 'USERNAME_EMAIL_REQUIRED') {
          this.loginErrorMessages = [error.response.data.error.message];
        } else if (error.response.data.error.code === 'LOGIN_FAILED') {
          this.addSnackbarErrorHandler(error);
        } else {
          this.addSnackbarErrorHandler(error);
        }
      } else {
        this.addSnackbarErrorHandler(error);
      }
      this.loading = false;
    },
  },
  watch: {
    login() {
      if (this.loginErrorMessages.length > 0) this.loginErrorMessages = [];
    },
  },
};
</script>

<style scoped>
  .v-card {
    width: 100%;
    max-width: 370px;
  }

  .base-btn-color button {
    background-color: #005ea5 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue